import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { State } from '../../../State';
import { GetDoctorsRequest } from '../../../State/actions/mdqx/doctor/doctor.actions';
import { getDoctorsFetched } from '../../../State/selectors/mdqx/selectors';
@Injectable({
    providedIn: 'root'
})
export class DoctorResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getDoctorsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetDoctorsRequest())
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
